<template>
  <div>
    <label v-if="showLabel && label" :for="id" class="small font-weight-bold">
      {{ label }}
    </label>
    <span v-if="emptyDisplay && isEmptyValue" class="empty-value">
      {{ emptyDisplay }}
    </span>
    <vue-timepicker
        v-else
        :id="id"
        :value="value"
        @input="$emit('input', $event)"
        format="HH:mm"
        hide-clear-button
        input-width="100%"
        :disabled="disabled"
    ></vue-timepicker>
  </div>
</template>

<script>
export default {
  props: {
    /** @type {string} ID único del input */
    id: {
      type: String,
      required: true
    },
    /** @type {string} Etiqueta del campo */
    label: {
      type: String,
      default: ''
    },
    /** @typedef {Object} HoraTimepicker
     * @property {string} HH - Hora en formato HH
     * @property {string} mm - Minutos en formato mm */
    /** @type {HoraTimepicker|null} Valor seleccionado (v-model) */
    value: {
      type: Object,
      default: null
    },
    /** @type {boolean} Si el input está deshabilitado */
    disabled: {
      type: Boolean,
      default: false
    },
    /** @type {boolean} Si muestra la etiqueta */
    showLabel: {
      type: Boolean,
      default: true
    },
    /** @type {string} Texto a mostrar cuando el valor está vacío (ej: "--:--", "N/A") */
    emptyDisplay: {
      type: String,
      default: null
    }
  },

  computed: {
    isEmptyValue() {
      return !this.value || !this.value.HH || !this.value.mm || this.value.HH === '' || this.value.mm === '';
    }
  }
}
</script>

<style scoped>
.empty-value {
  display: inline-block;
  width: 100%;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 6px;
  background-color: #f8f9fa;
  color: #6c757d;
  font-weight: 600;
  border: 1px solid #dee2e6;
}
</style>